import pluralize from 'pluralize'
import type { ReactNode } from 'react'

import { Icon } from '@fv/client-components'
import type { LoadHandlingUnit } from '@fv/client-types'
import type { Workflow } from '@fv/models'

import { usePrettyNumber } from './usePrettyNumber'
import { useTypeNames } from './useTypeNames'

export const useItemDetailParts = () => {
  const { packageName } = useTypeNames()
  const prettyNumber = usePrettyNumber()

  return (item: LoadHandlingUnit, workflow: Workflow) => {
    const {
      freightClass,
      height,
      length,
      nmfcNumber,
      nmfcSubNumber,
      quantity,
      type,
      weight,
      weightUOM,
      width,
      stackable,
    } = item ?? {}

    let nmfc = nmfcNumber ? `${nmfcNumber}` : null
    if (nmfc && nmfcSubNumber) nmfc += `.${nmfcSubNumber}`
    const packaging = packageName(type).toLowerCase()

    const parts: ReactNode[] = [pluralize(packaging, quantity, true)]

    if (length) parts.push(`${length} x ${width} x ${height}`)
    if (weight) parts.push(`${prettyNumber(weight)} ${weightUOM}`)
    if (freightClass) parts.push(`Class ${freightClass}`)
    if (nmfc) parts.push(`NMFC ${nmfc}`)
    if (stackable) parts.push(`Stackable`)
    if (!stackable && workflow === 'ltl')
      parts.push(
        <span>
          <Icon icon="exclamation-triangle" className="color-warning" /> DO NOT
          STACK
        </span>,
      )
    return parts
  }
}
